import "./styles/style.css";
import { Routes, Route } from 'react-router-dom';

import Homepage from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Message from "./pages/Message";
import ForgotPass from "./pages/ForgetPass";

export default function App() {
  return (
    <div className="main">
      <Routes>
        <Route path="/" index exact element={<Homepage />}></Route>
        <Route path="/login" element={<Login />}></Route>
        <Route path="/register" element={<Register />}></Route>
        <Route path="/dashboard" element={<Dashboard />}></Route>
        <Route path="/:username" element={<Message />}></Route>
        <Route path="/forgot-password" element={<ForgotPass />}></Route>
      </Routes>
    </div>
  )
}